import { locale_en } from "./translation.en";

export const locale_en_GB = {
    "lang": "en-GB",
    "data": locale_en.data
}